export default __webpack_public_path__ + "static/media/28.0f17e681.png";